import { render, staticRenderFns } from "./NewAdmissionListPrint.vue?vue&type=template&id=01a83ea6&scoped=true&"
import script from "./NewAdmissionListPrint.vue?vue&type=script&lang=js&"
export * from "./NewAdmissionListPrint.vue?vue&type=script&lang=js&"
import style0 from "./NewAdmissionListPrint.vue?vue&type=style&index=0&id=01a83ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a83ea6",
  null
  
)

export default component.exports